import { render, staticRenderFns } from "./tab-filter.vue?vue&type=template&id=f90d72bc"
import script from "./tab-filter.vue?vue&type=script&lang=js"
export * from "./tab-filter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports